import styled, {css} from 'styled-components';

import {ActionButton as BaseActionButton, Button as BaseButton, mixins} from '@edna/components';

export const ActionButton = styled(BaseActionButton)`
  ${({theme}) => css`
    color: ${theme.palette.white};
    background-color: ${theme.palette.blue500};

    &:hover {
      color: ${theme.palette.white};
      background-color: ${theme.palette.blue600};
    }
  `}
`;

export const OptionIcon = styled.svg`
  margin-right: ${({theme}) => theme.spacing.s2};
`;

export const Button = styled(BaseButton)`
  ${mixins.stack({size: '1', direction: 'ROW', align: 'center'})}

  ${({theme}) => css`
    color: ${theme.palette.white};
    background-color: ${theme.palette.blue500};
    border-color: ${theme.palette.blue500};

    &:hover {
      color: ${theme.palette.white};
      background-color: ${theme.palette.blue600};
    }
  `}
`;

export const Header = styled.div`
  ${mixins.stack({size: '3', direction: 'ROW', align: 'center'})}

  ${({theme}) => css`
    margin-bottom: ${theme.spacing.s4};
  `}
`;
